// extracted by mini-css-extract-plugin
export default {"tooltip":"GeoMap_tooltip__+0CX+"};